import { getBusinessUnitConfig } from '@/modules/bu/registry.base';
import { getEffectiveBu } from '@/utils/bu.utils';

export function useApp() {
  const route = useRoute();

  const currentBuKey = computed(() =>
    getEffectiveBu({
      path_value: route.path,
      origin_value: window.location.origin,
      use_stored: true,
    }),
  );

  // Resolve UI chrome (name/logo/favicon) from BU registry for the current context.
  const currentBuConfig = computed(() => getBusinessUnitConfig(currentBuKey.value));

  return {
    currentApp: currentBuKey,
    currentAppName: computed(() => currentBuConfig.value?.label),
    currentAppLogo: computed(() => currentBuConfig.value?.logoPath),
    currentAppFavicon: computed(() => currentBuConfig.value?.faviconPath),
  };
}
